'use client'
import { FaTabletAlt } from "react-icons/fa";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useState } from "react";
import { LuCirclePlus } from "react-icons/lu";
import { LuCircleMinus } from "react-icons/lu";
import * as ICON from "react-icons/fa";
import { Tooltip } from "primereact/tooltip";

export const ProductFeatureInfo = ({features}) => {
    if(!features || features.length === 0) return null;
    const [activeIndex, setActiveIndex] = useState(0)
    const isActive = activeIndex === 0
    let data = features.map(x => ({...x, icon: ICON[x.icon] ? ICON[x.icon]() : <FaTabletAlt />}));
    return (
        <Accordion className='accodion-root mt-2' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

            <AccordionTab
                header={
                    <span className="flex align-items-center justify-content-between gap-2 w-full cursor-pointer">
                        <span className="font-bold white-space-nowrap" style={{ color: 'var(--primary-color)' }}>Product Key Features</span>
                        {isActive
                            ? <LuCircleMinus className='text-xl' style={{ color: 'var(--secondary-color)', flexShrink: 0 }} />
                            : <LuCirclePlus className='text-xl' style={{ color: 'var(--secondary-color)', flexShrink: 0 }} />
                        }
                    </span>
                }
            >
                <div className="flex align-items-center justify-content-start gap-2 flex-wrap">
                    {data.map((x, i) => {
                        return (<div key ={x?._id}>
                            <Tooltip target={`.text_${x._id}_tooltip`}  className="text-xs" position="top"/>

                            <div key={`icon-${i}`} data-pr-tooltip={x?.info} className={`text_${x._id}_tooltip cursor-pointer flex text-center border-round-md gap-1 w-10rem flex-column justify-content-center align-items-center border-1 p-2`}
                                style={{ borderColor: 'rgba(11,49,99,0.15)', background: '#fff' }}>
                                <i className="text-3xl" style={{ color: 'var(--secondary-color)' }}>{x?.icon}</i>
                                <span className="text-xs h-2rem" style={{ color: 'var(--primary-color)', fontWeight: 500 }}><small>{x?.title}</small></span>
                            </div></div>)
                    })}
                </div>
            </AccordionTab>
        </Accordion>)
}